module.exports = __webpack_public_path__ + "static/media/congaLo.9e77b3b3.wav";